/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Field_PhoneInputs */

const vi_cdo_field_phone = /** @type {(inputs: Cdo_Field_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại`)
};

/**

* @param {Cdo_Field_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_field_phone = /** @type {((inputs?: Cdo_Field_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Field_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_field_phone(inputs)
});